<template>
  <div class="flight-pad-bags">
    <div class="flight-pad-bags__flex">
      <div
        class="flight-pad-bags__bag-container"
        v-b-popover.hover.top="{
          content: 'Numero di bagagli personali inclusi per ogni passeggero adulto',
          customClass: 'b-popover--primary',
        }"
      >
        <vb-icon
          name="backpack"
          :size="22"
          :color="hand_bags_color"
          :icon_style="{
            '--color': hand_bags_color,
          }"
        />
        <span
          class="flight-pad-bags__quantity semibold"
          :style="{
            color: hand_bags_color,
          }"
        >
          {{ hand_bags }}
        </span>
      </div>
      <div
        class="flight-pad-bags__bag-container"
        v-b-popover.hover.top="{
          content: 'Numero di bagagli in stiva incluso per ogni passeggero adulto',
          customClass: 'b-popover--primary',
        }"
      >
        <vb-icon
          name="luggage"
          :size="30"
          :color="luggage_bags_color"
          :icon_style="{
            '--color': luggage_bags_color,
          }"
        />
        <span
          class="flight-pad-bags__quantity semibold"
          :style="{
            color: luggage_bags_color,
          }"
        >
          {{ luggage_bags }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  bags_quantity_color,
  hand_bags_per_adult,
  luggage_bags_per_adult,
} from "./script/utilities";

export default {
  name: "flight-pad-bags",
  props: {
    flight_offer: Object,
    itinerary_index: Number,
  },
  methods: {
    bags_quantity_color,
  },
  computed: {
    hand_bags() {
      return hand_bags_per_adult(this.flight_offer);
    },
    luggage_bags() {
      return luggage_bags_per_adult(this.flight_offer, this.itinerary_index);
    },
    hand_bags_color() {
      return this.bags_quantity_color(this.hand_bags);
    },
    luggage_bags_color() {
      return this.bags_quantity_color(this.luggage_bags);
    },
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-bags {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;

  &__quantity {
    line-height: 1;
  }

  &__bag-container {
    display: flex;
    gap: 2.5px;

    &:first-child {
      margin-right: 5px;
    }

    &:last-child {
      margin-left: 5px;
    }
  }
}
</style>
